import {Container, Home, Options} from "./style"

import {FiHome} from "react-icons/fi"
import {FaGraduationCap, FaGlassCheers} from "react-icons/fa"
import {GiLargeDress} from "react-icons/gi"

import {useDashboardContext} from "../../providers/DashboardContext/index"


const Header = () => {

    const {setSelectedPartyType} = useDashboardContext()

    return (
        <Container>
            <Home>
                <button type="button" onClick={() => setSelectedPartyType("None")}>
                    <FiHome/>
                </button>
            </Home>
            <Options>
                <button type="button" onClick={() => setSelectedPartyType("Graduation")}>
                    <FaGraduationCap/>
                </button>
                <button type="button" onClick={() => setSelectedPartyType("Wedding")}>
                    <GiLargeDress/>
                </button>
                <button type="button" onClick={() => setSelectedPartyType("Confraternization")}>
                    <FaGlassCheers/>
                </button>
            </Options>
        </Container>
    )
}


export default Header